import { toTitleCase } from "./string";

const convertDataToTableView = (items, cells) => {
  return items.map((item) => {
    let row = {};
    cells
      .filter((cell) => cell.export !== false)
      .map((cell) => {
        const cellTitle =
          cell.exportLabel || toTitleCase(cell.label || cell.id);
        row[cellTitle] = cell.render ? cell.render(item, true) : item[cell.id];
        return cell;
      });
    return row;
  });
};

const convertDataToTableViewObt = (items, cells) => {
  const newItems = [];

  items.forEach((item) => {
    item?.details?.forEach((det) => {
      newItems.push({
        ...item,
        tracking_number: det.tracking_number,
        sku: det.sku,
        status: det.status || item.status,
      });
    });
  });

  return convertDataToTableView(newItems, cells);
};

export { convertDataToTableView, convertDataToTableViewObt };
